import { Injectable } from '@angular/core';
import { isDefined } from 'src/app/shared/utility/verify.lib';

@Injectable({
  providedIn: 'root',
})
export class UtagHelperService {
    private utag: any = (window as any).utag;

  public getLanguage(): string {
    let returnValue: string = 'en';

    if (isDefined(() =>  this.utag.data.site_language)) {
        returnValue = this.utag.data.site_language;
      }

      return returnValue
  }

  public getCountry(): string {
    let returnValue: string = 'en';

    if (isDefined(() =>  this.utag.data.site_country)) {
        returnValue = this.utag.data.site_country;
      }

      return returnValue
  }

  public getAppName(): string {
    let returnValue: string = '';

    if (isDefined(() =>  this.utag.data.app_name)) {
        returnValue = this.utag.data.app_name;
      }

      return returnValue
  }
}
